import { NotificationProviderSettingsDto } from '@/api/notification-settings/queries';

export class NotificationSettingsState {
    public id: string = '';
    public autoWatchMyCards: boolean = null;

    public changeRights: NotificationProviderSettings = new NotificationProviderSettings();

    public firstTimeVisitedMyBoard: NotificationProviderSettings = new NotificationProviderSettings();

    public invitedMe: NotificationProviderSettings = new NotificationProviderSettings();

    public someoneCommentedOrChangedWatchedCards: NotificationProviderSettings = new NotificationProviderSettings();

    public someoneMentionedMe: NotificationProviderSettings = new NotificationProviderSettings();

    public someonePostedOnBoardDiscussions: NotificationProviderSettings = new NotificationProviderSettings();

    public slackIsConnected: boolean = null;
}

export class NotificationProviderSettings {
    public slack: boolean;
    public email: boolean;
    public inApp: boolean;

    public mapFrom = (setting: any) => {
        this.slack = setting.Slack;
        this.email = setting.Email;
        this.inApp = setting.InApp;
    };

    public mapToDto = (): NotificationProviderSettingsDto => {
        const dto = new NotificationProviderSettingsDto();

        dto.Slack = this.slack;
        dto.Email = this.email;
        dto.InApp = this.inApp;

        return dto;
    };

    public copy = (): NotificationProviderSettings => {
        const a = new NotificationProviderSettings();

        a.inApp = this.inApp;
        a.email = this.email;
        a.slack = this.slack;

        return a;
    };
}
